module.exports = __webpack_public_path__ + "bdb61fd4283a9f97154b08a1bc265b61.svg";


//////////////////
// WEBPACK FOOTER
// ./client/views/NotFoundView/images/404.svg?external
// module id = 1678
// module chunks = 0